export const VACATION_RENTALS_FF = 'vr_prebooking_enabled_FF';
export const DISABLE_PACKAGES_FF = 'prebooking_packages_tab_disabled';
